import { devtools, persist } from 'zustand/middleware'
import { create } from '../store'
import { getStorageKey } from '@/shared/helpers/localStorage'

interface AuthStore {
  selectedPublicKey: string;
  selectedWalletType: string;
  setSelectedPublicKey: (publicKey: string) => void;
  setSelectedWalletType: (selectedWalletType: string) => void;
  setUserId: (userId: string | null) => void;
  userId: string | null;

  clear: () => void;
}

export const useAuthStore = create<AuthStore>()(
  devtools(
    persist(
      (set) => ({
        userId: null,
        setUserId: (userId: string | null) => set(() => ({ userId }), false, 'setUserId'),
        selectedWalletType: '',
        setSelectedWalletType: (selectedWalletType) => set(() => ({ selectedWalletType }), false, 'setSelectedWalletType'),
        selectedPublicKey: '',
        setSelectedPublicKey: (publicKey) => set(() => ({ selectedPublicKey: publicKey }), false, 'setSelectedPublicKey'),

        clear: () => set({
          selectedWalletType: '',
          selectedPublicKey: '',
          userId: null,
        })
      }),
      {
        name: getStorageKey('godefi:authStorage'),
      },
    ),
    {
      name: 'useAuthStore',
    },
  ),
)
